import React from 'react';
import FormModal from '../../../Modals/FormModal';
import clsx from 'clsx';

interface Props {
  isOpen: boolean;
  log: any;
  onClose: () => void;
  onDownloadRequest?: (id: number) => void;
  onDownloadResponse?: (id: number) => void;
}

const DteInvalidationDetailModal: React.FC<Props> = ({
  isOpen,
  log,
  onClose,
  onDownloadRequest,
  onDownloadResponse,
}) => {
  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Detalle de Error de Anulación"
      maxWidth="max-w-5xl"
      overlayBg="black"
      zIndex="front"
    >
      {!log ? (
        <EmptyState />
      ) : (
        <div className="space-y-8 text-sm">

          {/* 🔹 DOCUMENTO */}
          <Section title="Información del Documento">
            <Grid>
              <DetailItem label="ID Registro" value={log.id} />
              <DetailItem label="Documento ID" value={log.documentId} />
              <DetailItem label="Categoría" value={log.documentCategory} />
              <DetailItem label="Tipo DTE" value={log.documentType} />
              <DetailItem label="Código Generación" value={log.generationCode} />
              <DetailItem
                label="Ambiente"
                value={log.ambiente === '00' ? 'Pruebas' : 'Producción'}
              />
              <DetailItem label="Fecha" value={log.createdAt} />
            </Grid>
          </Section>

          {/* 🔹 ENVÍO HACIENDA */}
          <Section title="Información de Envío">
            <Grid>
              <DetailItem label="ID Envío" value={log.idEnvio} />
              <DetailItem
                label="HTTP Status"
                value={
                  <StatusBadge status={log.httpStatus} />
                }
              />
            </Grid>
          </Section>

          {/* 🔹 MENSAJE ERROR */}
          {log.errorMessage && (
            <Section title="Mensaje de Error">
              <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-md p-4 text-xs whitespace-pre-wrap break-words">
                {log.errorMessage}
              </div>
            </Section>
          )}

          {/* 🔹 DESCARGAS */}
          {(log.hasRequestJson || log.hasResponseJson) && (
            <Section title="Descargas">
              <div className="flex gap-4 flex-wrap">
                {log.hasRequestJson && (
                  <ActionButton
                    label="Descargar JSON Enviado"
                    onClick={() => onDownloadRequest?.(log.id)}
                  />
                )}

                {log.hasResponseJson && (
                  <ActionButton
                    label="Descargar Respuesta Hacienda"
                    variant="secondary"
                    onClick={() => onDownloadResponse?.(log.id)}
                  />
                )}
              </div>
            </Section>
          )}
        </div>
      )}
    </FormModal>
  );
};

export default DteInvalidationDetailModal;



const Section = ({ title, children }: any) => (
  <div className="space-y-3">
    <h3 className="text-sm font-semibold text-slate-700 dark:text-slate-200 border-b pb-1">
      {title}
    </h3>
    {children}
  </div>
);

const Grid = ({ children }: any) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    {children}
  </div>
);

const DetailItem = ({ label, value }: any) => (
  <div>
    <p className="text-xs text-slate-500 dark:text-slate-400">{label}</p>
    <p className="font-medium text-slate-800 dark:text-slate-100 break-words">
      {value ?? '-'}
    </p>
  </div>
);

const StatusBadge = ({ status }: { status?: number }) => {
  const color =
    status && status >= 200 && status < 300
      ? 'bg-green-100 text-green-700'
      : 'bg-red-100 text-red-700';

  return (
    <span className={clsx('px-2 py-1 rounded text-xs font-semibold', color)}>
      {status ?? '-'}
    </span>
  );
};

const ActionButton = ({
  label,
  onClick,
  variant = 'primary',
}: any) => {
  const base =
    'px-4 py-2 rounded text-xs font-medium transition';

  const styles =
    variant === 'secondary'
      ? 'bg-slate-200 hover:bg-slate-300 text-slate-800'
      : 'bg-primary text-white hover:bg-opacity-90';

  return (
    <button onClick={onClick} className={`${base} ${styles}`}>
      {label}
    </button>
  );
};

const EmptyState = () => (
  <div className="text-center text-sm text-slate-500 py-8">
    No hay información disponible.
  </div>
);
